import {getColor} from "@/styles/ThemeConfig";
import styled, {css} from "styled-components";
import {breakpoints} from "@/styles/sizes";

export const CkEditorPagesContentWrapper = styled.div`
    padding-top:50px;
    padding-bottom:100px;
    
    h1{
        text-align: center;
        text-transform: uppercase;
        margin-bottom: 30px;
      }
      a{
        color:${getColor('gold')};
      }

    p{
        font-size: 1.2em;
    }
`

export const DangerousDescriptionWrapper = styled.div`
    font-family: "Josefin Sans", sans-serif;
    font-size: 1.4em !important;
    line-height: 1.5em;
    
    @media only screen and (${breakpoints.mobile}) {
        padding:0 20px;
    }
    
    p {
        font-size: 1em !important;
        line-height: 1.5em;
        @media only screen and (${breakpoints.mobile}) {
            font-size: 18px !important;
        }
    }

    a {
        text-decoration: none;
        color: ${getColor('gold')};
        font-size: 1em !important;
        line-height: 1.5em;
        @media only screen and (${breakpoints.mobile}) {
            font-size: 18px !important;
        }
    }

    /* Apply custom styles passed via the customStyle prop */
    ${({ customStyle }) => customStyle && css`${customStyle}`}
`;

